import { render, staticRenderFns } from "./SithMomPjReleaseBatch.vue?vue&type=template&id=244c7cc4&scoped=true&"
import script from "./SithMomPjReleaseBatch.vue?vue&type=script&lang=js&"
export * from "./SithMomPjReleaseBatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244c7cc4",
  null
  
)

export default component.exports